module.exports = {"350803001":"凤城街道","350803101":"坎市镇","350803102":"下洋镇","350803103":"湖雷镇","350803104":"高陂镇","350803105":"抚市镇","350803106":"湖坑镇","350803107":"培丰镇","350803108":"龙潭镇","350803109":"峰市镇","350803110":"城郊镇","350803111":"仙师镇","350803112":"虎岗镇","350803201":"西溪乡","350803202":"金砂乡","350803204":"洪山乡","350803205":"湖山乡","350803206":"岐岭乡","350803207":"古竹乡","350803208":"堂堡乡","350803209":"合溪乡","350803211":"大溪乡","350803212":"陈东乡","350803213":"高头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350803.json
// module id = 1231
// module chunks = 0